import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLMenuElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMenuElement
 */
export default class HTMLMenuElement extends HTMLElement {}
